import React, { useState, useEffect } from 'react'
import './styles.css'
import HomePage from '../Home'
import Login from '../Login'
import Register from '../Register'
import Dashboard from '../Dashboard'
import ForgetPass from '../ForgetPass'
import Location from '../Location'
import Profile from '../Profile'
import Admin from '../Admin'
import Policy from '../Policy'
import Students from '../Students'
import { CircularProgress } from '@material-ui/core'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { createBrowserHistory } from "history";
import firebase from '../firebase'
import Fights from '../Fights'
import Tournament from '../Tournament'


export default function App() {

	const [firebaseInitialized, setFirebaseInitialized] = useState(false)
	const baseURL = process.env.PUBLIC_URL;
	const history = createBrowserHistory();

	useEffect(() => {
		firebase.isInitialized().then(val => {
			setFirebaseInitialized(val)
		})
	})

	return firebaseInitialized !== false ? (
			<Router history={history}>
				<Switch>
					<Route exact path={baseURL + "/"} component={HomePage} />
					<Route exact path={baseURL + "/login"} component={Login} />
					<Route exact path={baseURL + "/register"} component={Register} />
					<Route exact path={baseURL + "/dashboard"} component={Dashboard} />
					<Route exact path={baseURL + "/forget-pass"} component={ForgetPass} />
					<Route exact path={baseURL + "/admin"} component={Admin} />
					<Route exact path={baseURL + "/location"} component={Location} />
					<Route exact path={baseURL + "/profile"} component={Profile} />
					<Route exact path={baseURL + "/policy"} component={Policy} />
					<Route exact path={baseURL + "/students"} component={Students} />
					<Route exact path={baseURL + "/fights"} component={Fights} />
					<Route exact path={baseURL + "/tournament"} component={Tournament} />
				</Switch>
			</Router>
	) : <div class="loading"><CircularProgress /></div>
}